import { useEffect } from 'react';

import { ProgressBarWizard } from '@bambi/component-library/src/components/Wizard/ProgressBarWizard';
import { noop } from 'lodash-es';
import { FormProvider, useForm } from 'react-hook-form';

import { useAppSelector } from 'src/app/store/hooks';

import { RouteTemplateFormStep0 } from './RouteTemplateFormStep0';
import { RouteTemplateFormStep1 } from './RouteTemplateFormStep1';
import { RouteTemplateFormStep2 } from './RouteTemplateFormStep2';
import { RouteTemplateFormValues } from './types';

import type { WizardStepConfig } from '@bambi/component-library/src/components/Wizard/base/types';

interface RouteTemplateFormProps {
  onFormDirty?: (dirty: boolean) => void;
  onCancel?: () => void;
  defaultValues?: Partial<RouteTemplateFormValues>;
}
export function RouteTemplateForm({
  onCancel,
  onFormDirty,
  defaultValues,
}: RouteTemplateFormProps) {
  const form = useForm<RouteTemplateFormValues>({
    mode: 'all',
    defaultValues: {
      trip_templates: [],
      allow_rbr_trips: true,
      ...defaultValues,
    },
  });

  useEffect(() => {
    form.setValue(
      'multiload_trip_templates',
      defaultValues?.multiload_trip_templates ?? []
    );
  }, [defaultValues?.multiload_trip_templates, form]);

  let steps: WizardStepConfig[] = [
    {
      title: 'Route Template',
      render: ({ next, setStep }) => {
        return (
          <RouteTemplateFormStep1
            onCancel={onCancel ?? noop}
            onNext={next}
            setStep={setStep}
          />
        );
      },
    },
    {
      title: 'Trip Matchers',
      render: ({ setStep }) => {
        return (
          <RouteTemplateFormStep2
            onCancel={onCancel ?? noop}
            onSubmit={() => {}}
            setStep={setStep}
          />
        );
      },
    },
  ];

  const workflowMode = useAppSelector((state) => state.routeTemplates.workflow);
  // In bulk create mode
  if (workflowMode === 'bulk') {
    steps = [
      {
        title: 'Select Trips',
        render: ({ next }) => {
          return (
            <RouteTemplateFormStep0 onCancel={onCancel ?? noop} onNext={next} />
          );
        },
      },
      steps[0],
      // Skip the trip matcher step
    ];
  }

  useEffect(() => {
    if (form.formState.isDirty) {
      onFormDirty?.(true);
    }
  }, [form.formState.isDirty, onFormDirty]);

  useEffect(() => {
    form.reset();
    onFormDirty?.(false);
  }, [form, onFormDirty]);

  return (
    <FormProvider {...form}>
      <ProgressBarWizard steps={steps} />
    </FormProvider>
  );
}
